var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCustomer(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Customer",
    className: "cls-1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "customer-2",
    "data-name": "customer",
    transform: "translate(0.851 0.549)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_204",
    "data-name": "Group 204",
    transform: "translate(7.034)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_203",
    "data-name": "Group 203"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_144",
    "data-name": "Path 144",
    className: "cls-2",
    d: "M212.072,0a2.069,2.069,0,0,0-2.043,2.043,2.069,2.069,0,0,0,2.043,2.043,2.044,2.044,0,0,0,0-4.087Z",
    transform: "translate(-210.029)",
    fill: "#FFFFFF"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_206",
    "data-name": "Group 206",
    transform: "translate(6.029 4.087)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_205",
    "data-name": "Group 205"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_145",
    "data-name": "Path 145",
    className: "cls-2",
    d: "M185.308,122a3,3,0,0,1-2.231,1,3.07,3.07,0,0,1-2.264-1,2.992,2.992,0,0,0-.784,2.01v.5a.5.5,0,0,0,.5.5h5.058a.5.5,0,0,0,.5-.5v-.5A2.992,2.992,0,0,0,185.308,122Z",
    transform: "translate(-180.029 -122)",
    fill: "#FFFFFF"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_208",
    "data-name": "Group 208",
    transform: "translate(0 9.732)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_207",
    "data-name": "Group 207",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_146",
    "data-name": "Path 146",
    className: "cls-2",
    d: "M4.879,296.222l-2.56-5.133a1,1,0,0,0-1.345-.452l-.669.332a.5.5,0,0,0-.226.675l3.015,6.029a.5.5,0,0,0,.673.226l.661-.327A1,1,0,0,0,4.879,296.222Z",
    transform: "translate(-0.024 -290.532)",
    fill: "#FFFFFF"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_210",
    "data-name": "Group 210",
    transform: "translate(2.981 7.921)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_209",
    "data-name": "Group 209"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_147",
    "data-name": "Path 147",
    className: "cls-2",
    d: "M102.773,236.854a1,1,0,0,0-1.326.131L98.7,240.361a1.215,1.215,0,0,1-.744.322H95.615a.5.5,0,1,1,0-1h2.01a1,1,0,0,0,0-2.01H94.992c-.25,0-.375-.159-.573-.332a3.5,3.5,0,0,0-3.119-.764,3.666,3.666,0,0,0-1.543.77l-.015-.012-.727.64,2.856,5.727h5.753a3.027,3.027,0,0,0,2.412-1.206l2.948-4.221A1.013,1.013,0,0,0,102.773,236.854Z",
    transform: "translate(-89.016 -236.479)",
    fill: "#FFFFFF"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCustomer);
export default __webpack_public_path__ + "static/media/Customer.059f641b853cf5533323ad1691ff3268.svg";
export { ForwardRef as ReactComponent };